<template>
  <div id="Layout">
    <div class="sideMenu" ref='side' v-if='sideMenu && showMainView'>
      <div class="menuTitle">
        <span v-if='!toCollapsed'>
 药房ERP
        </span>
              <span  :class='{"iconfont":true, "collapsed":!toCollapsed,"collapsedIcon":true}' @click='collapsed'>&#xe60a;</span>
        <!-- <lk-button type='text' @click='collapsed'> 收</lk-button> -->
      </div>
      <sideMenu ref='sideMenu' v-if="showMainView && !toCollapsed" :hasCashier='hasCashier'></sideMenu>
      <collapsedMenu v-if='toCollapsed'></collapsedMenu>
      <div :class='{"cashierContainer":true,"collapsedCashier":toCollapsed}' v-if='hasCashier'>
        <lk-button type='primary' long @click='toCashier' >
          <div>
              <span class="iconfont mr8">&#xe633;</span>
              <span v-if='!toCollapsed'>收银台</span>
          </div>
        </lk-button>
      </div>
    </div>
    <div class="mainContainer clear" ref='main'   v-if="showMainView">
      <MedicalInfo/>
      <Header>
        <span v-if="showMainView">
          <lk-dropdown placement="bottom-start" style="margin-right: 30px;" v-if="showTitle">
            <a @click="showHistory" class='btnIcon'>
              <span class="iconfont mr8">&#xe614;</span>
              <span>操作日志</span>
            </a>
          </lk-dropdown>
           <lk-dropdown placement="bottom-start" style="margin-right: 30px;" v-if="showTitle">
            <DownloadCart ref="downloadCart" :count="0"></DownloadCart>
          </lk-dropdown>
          <lk-dropdown placement="bottom-start" style="margin-right: 30px;" v-if="showTitle">
            <a href="javascript:void(0)"  @click="showDrawer"
              :class="[
                'btnIcon',
                {
                  'hasMessage': messageSum!=0
                }
              ]">
              <span class="iconfont mr8">&#xe60b;</span>
              <span>待办事项</span>
            </a>
          </lk-dropdown>

          <lk-dropdown class="mr" placement="bottom-start" @on-click="handleAccountCenter">
            <a href="javascript:void(0)" class="btnIcon">
              <span  class='iconfont mr8'>&#xe60c;</span>
                 <span>{{userInfo.name+'-'+userInfo.phone}}</span>
            </a>
            <lk-dropdown-menu slot="list">
              <lk-dropdown-item name='0'>切换账号</lk-dropdown-item>
              <lk-dropdown-item name='myInfo'>我的资料</lk-dropdown-item>
              <lk-dropdown-item name='editPassword'>修改密码</lk-dropdown-item>
              <lk-dropdown-item name='1'>登出</lk-dropdown-item>
            </lk-dropdown-menu>
          </lk-dropdown>
        </span>
        <span v-else>
          <lk-button type="text" @click="showLogin=true">登录</lk-button>
        </span>

        <MessageDrawer v-model='drawerVisible' @resetRoute='resetRoute'></MessageDrawer>
      </Header>
      <router-view :key="key" v-if='showView'></router-view>

      <footer class="footer">©零氪科技 京ICP备15001843号-1</footer>
    </div>
 <DTPModal v-model='nextModal' content='当前页面未提交，是否提交后离开？' @handleCancel='hanldeToNext' @confirm='hanldeStay' confirmText='提交'></DTPModal>
 <MultiAccountModal v-model='showMultiAccountModal' @reSetAuthority='authority()'></MultiAccountModal>
  <PasswordModal v-model='showPassword'></PasswordModal>
  </div>
</template>

<script>
import hotkeys from 'hotkeys-js';
import sideMenu from './components/sideMenu/sideMenu.vue';
import utils from './libs/utils';
import user from './services/user';
import collapsedMenu from './components/collapsedMenu/MainMenu.vue';
import MessageDrawer from './components/message/MessageDrawer';
import DTPModal from './components/DTPModal';
import MultiAccountModal from './components/MultiAccountModal.vue';
import PasswordModal from './components/PasswordModal';
import authority from './mixins/authority';
import permission from './mixins/permission';
import DownloadCart from './components/download/DownloadCart';
import MedicalInfo from './components/insurance/MedicalInfo';
import inventory from './services/inventory';
import inventoryLimitedPages from './libs/InventoryOpeMenuLimit';

export default {
  name: 'Layout',
  components: {
    sideMenu,
    collapsedMenu,
    DTPModal,
    MessageDrawer,
    MultiAccountModal,
    PasswordModal,
    DownloadCart,
    MedicalInfo,
  },
  mixins: [authority, permission],
  data() {
    return {
      showTitle: true,
      showView: true,
      showMultiAccountModal: false,
      showPassword: false,
      nextModal: false,
      nextRouter: '',
      canNext: false,
      toCashierLoading: false,
      isLogoutLoading: false,
      loading: false,
      toCollapsed: false,
      key: this.$route.name,
      showLogin: false,
      ruleValidate: {},
      forceUpdate: 0,
      showMainView: true,
      user: {
        user_real_name: 'test',
      },
      navMenus: null,
      drawerVisible: false,
      messageSum: 0,
      announcementData: [],
      approvalData: [],
      goodsWarnData: [],
      cardWarnData: [],
      otherData: [],
    };
  },

  methods: {
    resetRoute() {
      this.showView = false;
      this.$nextTick(() => {
        this.showView = true;
      });
    },
    getMenuLimitStatus() {
      return new Promise((reslove) => {
        inventory.getStocktakingStatus().then((res) => {
          if (res.data.status === 200) {
            if (res.data.data.limit === 2 || res.data.data.limit === 3) {
              reslove(true);
            } else {
              this.$Modal.warning({
                title: '暗盘盘点中，限制库存操作',
                content: `<p>${res.data.data.content}</p>`,
                onOk: () => {},
              });
              reslove(false);
            }
          } else {
            reslove(true);
          }
        }).catch(err => {
          utils.handleError(err);
          reslove(true);
        })
      })
    },
    // reSetAuthority(){this.authority},
    async toCashier(type) {
      const status = await this.getMenuLimitStatus();
      if (!status) {
        return
      }
      if (this.toCashierLoading) {
        return;
      }
      const res = [1, 2, 3].includes(Number.parseInt(type, 0));// Number.isNaN(type);
      this.toCashierLoading = true;
      localStorage.setItem('testCashier', new Date().getTime());
      setTimeout(() => {
        const cashierIsActive = localStorage.getItem('cashierIsActive') * 1;
        new Date().getTime() - cashierIsActive < 800 ? this.$Message.error('您已经打开收银台') : window.open(`${window.location.origin}/branch${window.location.pathname}#/cashier/cashierTabs?type=${res ? type : 1}`);
        this.toCashierLoading = false;
      }, 500);
    },

    showDrawer() {
      this.drawerVisible = true;
    },
    // 操作日志
    showHistory() {
      this.$router.push({
        name: 'history',
      });
    },

    collapsed() {
      this.toCollapsed = !this.toCollapsed;
      if (this.toCollapsed) {
        this.$refs.main.style.marginLeft = '64px';
        this.$refs.side.style.width = '64px';
        this.$refs.side.style.overflow = 'visible';
      } else {
        this.$refs.main.style.marginLeft = '220px';
        this.$refs.side.style.overflow = 'auto';
        this.$refs.side.style.width = '220px';
      }
    },
    handleAccountCenter(val) {
      if (val * 1 === 1) {
        if (this.isLogoutLoading) {
          return;
        }
        this.isLogoutLoading = true;
        user.logout().then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('登出成功');
            window.location.reload(true);
          } else {
            this.$Message.error(res.data.error);
          }
          this.isLogoutLoading = false;
        }).catch((err) => {
          this.isLogoutLoading = false;
          utils.handleError(err);
        });
      } else if (val * 1 === 0) {
        this.showMultiAccountModal = true;
        this.isLogoutLoading = false;
      } else if (val === 'editPassword') {
        this.showPassword = true;
      } else if (val === 'myInfo') {
        if (this.userInfo.roleType === 2) {
          this.$router.push({ name: 'personalStoreEdit', params: { id: this.userInfo.id } });
        } else {
          this.$router.push({ name: 'personalHQEdit', params: { id: this.userInfo.id } });
        }
      }
    },


    handleRouterGuard() {
      this.$router.beforeEach((to, from, next) => {
        if (this.canToNext || !this.$store.state.app.enableLeaveModal) {
          this.canToNext = false;
          this.$store.commit('setLeaveModal', false);
          next();
        } else {
          this.nextModal = true;
          this.nextRouter = to.name;
          this.$nextTick(() => {
            this.$refs.sideMenu.resetActive();
          });
        }
      });
    },
    hanldeStay() {
      this.nextModal = false;
    },
    hanldeToNext() {
      this.canToNext = true;
      this.nextModal = false;
      this.$router.push({ name: this.nextRouter });
    },
    handleRender(limitTimeRange) {
      this.$Modal.warning({
        title: '提示',
        content: `<p>该报表暂时不支持查看，请关注消息通知或联系管理员，限制查看时间：</p><p>${limitTimeRange}</p>`,
        onOk: () => {
          this.$router.push({ name: 'messageList' });
        },
      });
    },
    getMenusLimit() {
      this.$store.commit('setDisableLoading', true);
      inventory.getStocktakingStatus().then((res) => {
        if (res.data.status === 200) {
          if (res.data.data.limit) { // 2正常, 1盘点开始需要跳到首页
            const lastValue = localStorage.getItem('limit') || 2; // 如果上次值不存在默认为2
            localStorage.setItem('limit', res.data.data.limit);
            if ((lastValue == 2 || lastValue == 3) && res.data.data.limit === 1) {
              if (!this.identifyRoute(location.hash)) {
                this.$router.push({ name: 'messageList' });
              }
            } else if (res.data.data.limit === 3) {
              const idx = this.$route.path.lastIndexOf('/');
              const path = this.$route.path.substring(idx + 1);
              if (inventoryLimitedPages.limitedFormMenus.includes(path)) {
                this.handleRender(res.data.data.limitTimeRange || '');
              }
            }
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    identifyRoute(route) {
      let boolean = false;
      inventoryLimitedPages.noNeedRefreshPages.forEach(item => {
        if (route.indexOf(item) !== -1) {
          boolean = true;
        }
      })
      return boolean
    },
  },
  computed: {
    userInfo() {
      return {

        ...this.$store.state.user.info, roleType: this.$store.state.user.roleType,
      };
    },
    sideMenu() {
      return !this.$store.state.app.disableSideMenu;
    },


    hasCashier() {
      return this.$store.state.app.permissionList.includes('addSalesOrder');
    },

  },


  mounted() {
    // console.log('user-----', this.$store.state.storeInfo.id);
    const path = this.$route.path;
    if (path) {
      const routeArr = path.split('/');
      if ((routeArr.length && (routeArr.includes('incognito')))
      || [414, 95].includes(this.$store.state.storeInfo.id)) {
        this.showTitle = false;
      }
    }
    hotkeys('ctrl+1,ctrl+2,ctrl+3', (e) => {
      this.toCashier(e.key);
    });

    this.$route.params.isLogin && (this.showMultiAccountModal = true);
    setInterval(() => {
      this.getMenusLimit();
    }, 1000 * 30);
  },
};
</script>

<style lang="less">
.sideMenu {
  width: 220px;
  background: #151833;
  height: 100%;
  position: fixed;
  left: 0;
  overflow: auto;
  transition: all 0.5s;
  z-index: 10;

.cashierContainer{
  padding: 5px 16px;
  position: fixed;
  bottom: 0;
  width: 220px;
  z-index: 900;
}
.collapsedCashier{
  width: 64px;
  padding: 5px 12px;

}
  .menuTitle {
    color: #fff;
    font-size: 16px;
    height: 63px;
    line-height: 63px;
    padding-left: 24px;
    // background:  rgba(255, 255, 255, 0.1);
  }
}
#Layout {
  height: 100%;
  min-width:1280px;
}
.loginContainer {
  padding-right: 16px;
}
.captcha {
  display: inline-block;
  width: 130px;
  margin-left: 16px;
}
.mainContainer {
  margin-left: 220px;
  background: #f5f5f5;
  min-height: 100%;
   transition: all 0.5s;
  //  position: relative;
   z-index: 1;
  header {
    height: 44px;
    background: #fff;
    box-shadow: 0 0 0 2px #eee;
    margin-bottom: 2px;
    // line-height: 70px;
    text-align: right;
    padding-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  header > span {
    display: block;
    text-align: left
    // height: 30px;
  }
  .btnIcon {
    display: flex;
    align-items: center;
    // height: 60px
  }
}
.iconfont{
cursor: pointer;
}
.collapsed{
  float:right;
  margin-right: 30px
}
.collapsedIcon{
  opacity: 0.7;
}
td.ivu-table-expanded-cell {
    padding: 16px;
    background: #f8f8f9;
}
// .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
//   color: #515a6e;
// }
.info-container{
  display: flex;
  flex-wrap: wrap;
  .info-item{
    margin-right: 16px;
    padding-bottom: 12px;
    h4{
      margin-bottom: 4px;
    }
  }
}
.expand-item-container{
  display: flex;
  flex-wrap: wrap;
  padding-left: 24px;
  .expand-item{
    margin-right: 32px;
    line-height: 30px;
  }
}
.ivu-table-cell {
    padding-left: 16px;
    padding-right: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.drawer-title{
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 16px;
  .drawer-title-word{
    font-size: 16px;
    line-height: 32px;
    color: rgba(0,0,0,0.75);
  }
}
.ivu-dropdown a.hasMessage{
  color: #1890FF;
}
.dtp-select{
  &:focus{
    outline: none;
  }
  display: inline-block;
  color: #515a6e;
  background-color: #fff;
  height: 32px;
  line-height: 32px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  width: 100%;
}
.dtp-select[disabled]{
  color: #7b8497;
}
.info-item{
    &:before{
      content: "";
      display: inline-block;
      border: 1px solid #1890FF;
      margin-right: 6px;
      height: 12px;
      position: relative;
      top:2px;
    }
    h4{
      display: inline;
    }
    div{
      padding-left:8px;
    }
  }
.ivu-table-wrapper{
  overflow: unset;
}

.ivu-table-wrapper{
  overflow: unset;
}
.ivu-table-cell{
  .ivu-input-number{
    width: auto;
  }
  .ivu-btn{
    padding-left: 4px;
    padding-right: 4px;
  }
}
// 采购总数量，总金额
.sum-wrap{
  position: relative;
  top: -2px;
  left: 8px;
  width: 226px;
  height: 42px;
  .title-amount{
    font-size: 12px;
    color: rgba(46,46,46,0.65);
    position: absolute;
    left: 0;
    top: 0;
    line-height: 18px;
  }
  .content-amount{
    font-size: 18px;
    color: rgba(46,46,46,0.85);
    bottom: 0;
    left: 0;
    position: absolute;
    font-weight: 500;
  }
  .title-money{
    font-size: 12px;
    color: rgba(46,46,46,0.65);
    position: absolute;
    top: 0;
    left: 90px;
    line-height: 18px;
  }
  .content-money{
    font-size: 18px;
    color: rgba(46,46,46,0.85);
    bottom: 0;
    left: 92px;
    position: absolute;
    font-weight: 500;
  }
}
</style>
